module.exports = __webpack_public_path__ + "img/credit-card.bee8057d.svg";